import React from "react";
import { Button } from "../../../ui/button";

interface ThresholdCrossingClearButtonProps {
  id: number;
  onClearRequested?: (id: number) => void;
}

const ThresholdCrossingClearButton: React.FC<ThresholdCrossingClearButtonProps> = ({ id, onClearRequested }) => {
  const handleClear = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onClearRequested?.(id);
  };

  return (
    <Button
      variant="ghost"
      className="h-6 px-2 text-xs font-normal transition-colors bg-muted hover:bg-muted/80 text-foreground"
      onClick={handleClear}
      style={{ height: "20px", border: "none" }}
    >
      Clear
    </Button>
  );
};

export default ThresholdCrossingClearButton;
